import { InjectionToken } from '@angular/core';

export const WIDGETS_B2B_API_URL = new InjectionToken<string>(
  'WIDGETS_B2B_API_URL',
);
